import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import moment from "moment";
import {
  validaSoloNumero,
  formatMoneda,
  validaMonto,
  seleccionarCampo,
} from "../../../util/varios";
import axios from "axios";
import CatalogoComercio from "../../../catalogos/catalogoComercio";
import CatalogoInmueble from "../../../catalogos/catalogoInmueble";
import CatalogoReparador from "../../../catalogos/catalogoReparador";
import { Input, Radio, SearchInput, Select, Textarea } from "../../../ui/inputs/Input";
import { DangerButton, SuccessButton } from "../../../ui/buttons/Button";
export const OtrosImpuestos = (props) => {
  const [mostrarCatCom, setMostrarCatCom] = useState(false);
  const [mostrarCatInm, setMostrarCatInm] = useState(false);
  const [mostrarCatRep, setMostrarCatRep] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const idusuario = JSON.parse(localStorage.getItem("idusuario"));
  const [records, setRecords] = useState([]);
  const [values, setValues] = useState({
    idagente: "",
    nombre: "",
    fecha: fechaSistema,
    direccion: "",
    rif: "",
  });
  const [activo, setActivo] = useState(true);
  const [activo1, setActivo1] = useState(false);
  const [checkk] = useState(false);
  const [visibleF, setVisibleF] = useState("hidden");
  const [nomTablaContri, setNomTablaContri] = useState("");
  const [idComercio, setIdComercio] = useState(0);
  const [idContribuyente, setIdContribuyente] = useState(0);
  const txtConcepto = useRef();
  const cmbTipoImpuesto = useRef();
  const radioInmueble = useRef();
  const radioComercio = useRef();
  const radioGeneral = useRef();
  const txtMonto = useRef();
  const txtDireccion = useRef();
  const txtNombre = useRef();
  const txtRif = useRef();
  const txtIdReparador = useRef();
  const txtNombreReparador = useRef();
  const txtValorVh = useRef();
  const txtCapCarga = useRef();
  const btnCancela = useRef();
  const btnAcepta = useRef();
  let token = localStorage.getItem("jwtToken");
  let op = require("../../../../src/modulos/datos");
  const seleccionartipoIngreso = () => {
    setActivate(true);
    let campos = "*";
    let nomtab = "tipoimpuesto";
    let condi = "tipofacturacion = 0 OR tipofacturacion = 3";
    let orden = "idtipoimpuesto";
    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setRecords(response.data);
          if (response.data.length > 0) {
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const procesarFactura = (body) => {
    let endpoint = `${op.conexion}/api/Caja_Ingreso/crearfactura`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        setActivate(false);
        if (response.status == 200) {
          let msg = "Desea Facturar Otros Impuestos al mismo Contribuyente?.";
          setMensajesino({
            mostrar: true,
            titulo: "Confirmación.",
            texto: msg,
            icono: "confirmacion",
          });
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const onChange = (event) => {
    if (
      event.target.name === "direccion" ||
      event.target.name === "rif" ||
      event.target.name === "nombre" ||
      event.target.name === "concepto"
    ) {
      event.target.value = event.target.value.toUpperCase();
      setValues({ ...values, [event.target.name]: event.target.value });
    } else if (event.target.name === "tipoingreso") {
      if (cmbTipoImpuesto.current.selectedIndex === 42) {
        setVisibleF("visible");
      } else {
        setVisibleF("hidden");
        txtIdReparador.current.value = ``;
      }
    } else if (event.target.name === "idreparador") {
      validaSoloNumero(event);
    }
  };

  const onFecha = () => {
    let tfechas;
    let fecha = parseInt(fechaSistema.substring(1, 5));
    let mes = parseInt(fechaSistema.substring(6, 8));
    let dia = parseInt(fechaSistema.substring(9, 11));
    tfechas = fecha - 18;
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", ".")
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which >= 37 && event.which <= 40) {
      event.preventDefault();
    }

    if (event.which === 13) {
      if (event.target.id === "credito") {
        txtMonto.current.focus();
      }
    }
    if (event.which === 13) {
      if (event.target.id === "inputvalorvehiculo") {
        txtValorVh.current.focus();
      }
    }
    if (event.which === 13) {
      if (event.target.id === "inputcapacidadcarga") {
        txtCapCarga.current.focus();
      }
    }

    let e = event.target.value
      .replace(/\D/g, "")
      .replace(/([0-9])([0-9]{2})$/, "$1.$2")
      .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",");

    return formatMoneda(e);
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    txtMonto.current.value = "0,00";
    txtConcepto.current.value = "";
    cmbTipoImpuesto.current.selectedIndex = 0;
  };

  const handleCloseNo = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    txtNombre.current.value = "";
    txtRif.current.value = "";
    txtDireccion.current.value = "";
    txtConcepto.current.value = "";
    txtMonto.current.value = "";
    radioGeneral.current.checked = true;
    radioComercio.current.checked = checkk;
    radioInmueble.current.checked = checkk;
    props.onHideCancelar();
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;

    if (cmbTipoImpuesto.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe seleccionar el Tipo de Ingreso",
        icono: "informacion",
      });
      sigue = false;
      cmbTipoImpuesto.current.value = "";
      cmbTipoImpuesto.current.focus();
    } else if (txtNombre.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Campo Nombre no debe ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtNombre.current.value = "";
      txtNombre.current.focus();
    } else if (txtRif.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Campo Rif no debe ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtRif.current.value = "";
      txtRif.current.focus();
    } else if (txtDireccion.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Describa la Dirección",
        icono: "informacion",
      });
      sigue = false;
      txtDireccion.current.value = "";
      txtDireccion.current.focus();
    } else if (
      txtMonto.current.value.trim() === "" ||
      txtMonto.current.value.trim() === "0,00"
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Monto de la Factura no debe ir Vacio o ser Igual a 0",
        icono: "informacion",
      });
      sigue = false;
      txtMonto.current.value = "";
      txtMonto.current.focus();
    } else if (txtConcepto.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar el Concepto de la Factura",
        icono: "informacion",
      });
      sigue = false;
      txtConcepto.current.value = "";
      txtConcepto.current.focus();
    } else if (
      cmbTipoImpuesto.current.selectedIndex === 42 &&
      txtNombreReparador.current.value.trim() === ""
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El id del reparador no debe estar vacio",
        icono: "informacion",
      });
      sigue = false;
      txtIdReparador.current.focus();
    } else if (sigue) {
      var factu = [];
      var factudet = [];
      factu.push({
        totalinmpuesto: txtMonto.current.value
          .replace(/\./g, "")
          .replace(",", "."),
        totalrecargo: 0.0,
        totalinteres: 0.0,
        idtipoingreso: cmbTipoImpuesto.current.value,
        fechaemision: fechaSistema,
        descripcion:
          txtConcepto.current.value +
          (cmbTipoImpuesto.current.value === 42
            ? ``
            : " DE " +
              cmbTipoImpuesto.current[cmbTipoImpuesto.current.selectedIndex]
                .text),
        tablacontribuyente: nomTablaContri,
        status: 0,
        nombrecontri: txtNombre.current.value,
        direccioncontri: txtDireccion.current.value,
        cedrif: txtRif.current.value,
        totalmulta: 0.0,
        deducible: 0.0,
        facturador: idusuario,
        idreparador:
          txtIdReparador.current.value === ""
            ? "0"
            : txtIdReparador.current.value,
        idcomercio: idComercio,
      });

      factudet.push({
        montoimpuesto: txtMonto.current.value
          .replace(/\./g, "")
          .replace(",", "."),
        montorecargo: 0.0,
        montointeres: 0.0,
        periodo:
          fechaSistema.substring(6, 8) + "/" + fechaSistema.substring(0, 4),
      });

      let body = {
        idcontri: parseInt(idContribuyente, 10),
        factu: JSON.stringify(factu),
        factudet: JSON.stringify(factudet),
        nomtab: "",
        tipoimpu: "",
        idingremul: 0,
      };

      procesarFactura(body);
    }
  };

  const blanquear = () => {
    setActivo(true);
    setActivo1(false);
    setIdContribuyente(0);
    txtNombre.current.value = "";
    txtRif.current.value = "";
    txtDireccion.current.value = "";
    setNomTablaContri("");
    setIdComercio(0);
    setVisibleF("hidden");
    txtIdReparador.current.value = ``;
    txtNombreReparador.current.value = "";
  };

  const cancelar = (e) => {
    e.preventDefault();
    props.onHideCancelar();
    blanquear();
  };

  const handleCatalogo = () => {
    if (radioComercio.current.checked) {
      setMostrarCatCom(true);
    } else if (radioInmueble.current.checked) {
      setMostrarCatInm(true);
    }
  };

  const handleCatalogoRep = () => {
    setMostrarCatRep(true);
  };

  const handleCloseCatalogo = () => {
    if (radioComercio.current.checked) {
      setMostrarCatCom(false);
    } else if (radioInmueble.current.checked) {
      setMostrarCatInm(false);
    }
  };

  const handleCloseCatalogoRep = () => {
    setMostrarCatRep(false);
  };

  const handleAceptaCatalogo = (id) => {
    if (radioComercio.current.checked) {
      setMostrarCatCom(false);
    } else if (radioInmueble.current.checked) {
      setMostrarCatInm(false);
    }
    setIdContribuyente(id);
    datosContribuyente(id);
  };

  const handleAceptaCatalogoRep = (id, nombre) => {
    setMostrarCatRep(false);

    txtIdReparador.current.value = id;
    txtNombreReparador.current.value = nombre;
  };

  const SelectIdComercioFact = (idinmue) => {
    let endpoint = `${op.conexion}/api/Caja_Ingreso/selectIdComercioFactura?idinmue=${idinmue}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setIdComercio(
            response.data.idcomercio === null ? 0 : response.data.idcomercio
          );
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const datosContribuyente = (idcontri) => {
    let nomid = "";
    let nomtab = "";
    if (radioComercio.current.checked) {
      nomtab = "comercio";
      nomid = "idcomercio";
      setNomTablaContri("comercio");
    } else if (radioInmueble.current.checked) {
      nomtab = "inmueble";
      nomid = "idinmueble";
      setNomTablaContri("inmueble");
    }

    let endpoint;
    let campos = "*";

    endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idcontri}&nomtab=${nomtab}&nomid=${nomid}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            if (radioComercio.current.checked) {
              txtRif.current.value = response.data.rif;
              txtNombre.current.value = response.data.nombre;
              txtDireccion.current.value = response.data.direccion;
            } else if (radioInmueble.current.checked) {
              txtRif.current.value =
                response.data.cedulapropie === null
                  ? ""
                  : response.data.cedulapropie.trim();
              txtNombre.current.value =
                response.data.nombrepropie === null
                  ? ""
                  : response.data.nombrepropie.trim();
              txtDireccion.current.value =
                (response.data.dirinmue1 == null
                  ? ""
                  : response.data.dirinmue1.trim().toLowerCase() === "null"
                  ? ""
                  : response.data.dirinmue1.trim().toLowerCase() === ""
                  ? ""
                  : response.data.dirinmue1 !== null
                  ? response.data.dirinmue1.trim()
                  : "") +
                " " +
                (response.data.descridirinmue1 === null
                  ? ""
                  : response.data.descridirinmue1.trim().toLowerCase() ===
                    "null"
                  ? ""
                  : response.data.descridirinmue1.trim().toLowerCase() === ""
                  ? ""
                  : response.data.descridirinmue1 !== null
                  ? response.data.descridirinmue1.trim()
                  : "") +
                " " +
                (response.data.dirinmue2 === null
                  ? ""
                  : response.data.dirinmue2.trim().toLowerCase() === "null"
                  ? ""
                  : response.data.dirinmue2.trim().toLowerCase() === ""
                  ? ""
                  : response.data.dirinmue2 !== null
                  ? response.data.dirinmue2.trim()
                  : "") +
                " " +
                (response.data.descridirinmue2 === null
                  ? ""
                  : response.data.descridirinmue2.trim().toLowerCase() ===
                    "null"
                  ? ""
                  : response.data.descridirinmue2.trim().toLowerCase() === ""
                  ? ""
                  : response.data.descridirinmue2 !== null
                  ? response.data.descridirinmue2.trim()
                  : "") +
                " " +
                (response.data.ubicacionterreno === null
                  ? ""
                  : !response.data.ubicacionterreno.trim() === "ESQUINA"
                  ? (response.data.dirinmue3 === null
                      ? ""
                      : response.data.dirinmue3.trim().toLowerCase() === "null"
                      ? ""
                      : response.data.dirinmue3.trim().toLowerCase() === ""
                      ? ""
                      : response.data.dirinmue3 !== null
                      ? " ENTRE" + " " + response.data.dirinmue3.trim()
                      : "") +
                    " " +
                    (response.data.descridirinmue3 === null
                      ? ""
                      : response.data.descridirinmue3.trim().toLowerCase() ===
                        "null"
                      ? ""
                      : response.data.descridirinmue3.trim().toLowerCase() ===
                        ""
                      ? ""
                      : response.data.descridirinmue3 !== null
                      ? response.data.descridirinmue3.trim()
                      : "") +
                    " " +
                    (response.data.dirinmue4 === null
                      ? ""
                      : response.data.dirinmue4.trim().toLowerCase() === "null"
                      ? ""
                      : response.data.dirinmue4.trim().toLowerCase() === ""
                      ? ""
                      : response.data.dirinmue4 !== null
                      ? "Y" + " " + response.data.dirinmue4.trim()
                      : "") +
                    " " +
                    (response.data.descridirinmue4 === null
                      ? ""
                      : response.data.descridirinmue4.trim() === "null"
                      ? ""
                      : response.data.descridirinmue4.trim().toLowerCase() ===
                        "null"
                      ? ""
                      : response.data.descridirinmue4.trim().toLowerCase() ===
                        ""
                      ? ""
                      : response.data.descridirinmue4 !== null
                      ? response.data.descridirinmue4.trim()
                      : "") +
                    " "
                  : (response.data.dirinmue3 === null
                      ? ""
                      : response.data.dirinmue3.trim().toLowerCase() === "null"
                      ? ""
                      : response.data.dirinmue3.trim().toLowerCase() === ""
                      ? ""
                      : response.data.dirinmue3 !== null
                      ? " ESQUINA" + " " + response.data.dirinmue3.trim()
                      : "") +
                    " " +
                    (response.data.descridirinmue3 === null
                      ? ""
                      : response.data.descridirinmue3.trim().toLowerCase() ===
                        "null"
                      ? ""
                      : response.data.descridirinmue3.trim().toLowerCase() ===
                        ""
                      ? ""
                      : response.data.descridirinmue3 !== null
                      ? response.data.descridirinmue3.trim()
                      : "") +
                    " ") +
                (response.data.dirinmue5 === null
                  ? ""
                  : response.data.dirinmue5.trim().toLowerCase() === "null"
                  ? ""
                  : response.data.dirinmue5.trim().toLowerCase() === ""
                  ? ""
                  : response.data.dirinmue5 !== null
                  ? response.data.dirinmue5.trim()
                  : "") +
                " " +
                (response.data.descridirinmue5 === null
                  ? ""
                  : response.data.descridirinmue5.trim().toLowerCase() ===
                    "s/nombre"
                  ? ""
                  : response.data.descridirinmue5.trim().toLowerCase() === ""
                  ? ""
                  : response.data.descridirinmue5 !== null
                  ? response.data.descridirinmue5.trim()
                  : ""
                ).trim() +
                " " +
                (response.data.numcivicoinmue === null
                  ? ""
                  : response.data.numcivicoinmue.trim().toLowerCase() === "s/n"
                  ? ""
                  : response.data.numcivicoinmue.trim().toLowerCase() === ""
                  ? ""
                  : response.data.numcivicoinmue !== null
                  ? " Nº" + " " + response.data.numcivicoinmue.trim()
                  : "");
              SelectIdComercioFact(response.data.idinmueble);
            }
            setActivate(false);
          } else {
            setActivate(false);
            setTimeout(() => {
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "El Contribuyente no existe...",
                icono: "error",
              });
              txtRif.current.value = "";
              txtNombre.current.value = "";
              txtDireccion.current.value = "";
              blanquear();
            }, 100);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const datosReparador = (id) => {
    let campos =
      "idgestor, responsable, codigogestor, responsable,  fiscal, apellidos || ' ' || nombres AS nombres";
    let nomtab = "gestores";
    let nomid = "idgestor";
    let nomtab2 = "persona";
    let nomid2 = "responsable";
    let nomid3 = "cedula";

    let endpoint = `${op.conexion}/api/consulta/modeli11?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}&nomtab2=${nomtab2}&nomid2=${nomid2}&nomid3=${nomid3}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            if (response.data.fiscal === true) {
              setActivate(false);
              txtNombreReparador.current.value = response.data.nombres;
            } else {
              setActivate(false);
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "El Reparador no existe...",
                icono: "error",
              });
              txtIdReparador.current.value = "";
              txtNombreReparador.current.value = "";
            }
          } else {
            setActivate(false);
            setTimeout(() => {
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "El Contribuyente no existe...",
                icono: "error",
              });
              txtIdReparador.current.value = "";
              txtNombreReparador.current.value = "";
            }, 100);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const cerrarModal = () => {
    props.onHideRenderizar();
    props.onHideCancelar();
    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const onCheck = () => {
    setIdContribuyente(0);
    txtNombre.current.value = "";
    txtRif.current.value = "";
    txtDireccion.current.value = "";
    setNomTablaContri("");
    setIdComercio(0);
    if (radioComercio.current.checked || radioInmueble.current.checked) {
      setActivo(false);
      setActivo1(true);
    } else {
      setActivo(true);
      setActivo1(false);
    }
  };

  useEffect(() => {
    onFecha();
    seleccionartipoIngreso();
  }, []);

  const validarReparador = (event) => {
    event.preventDefault();
    txtNombreReparador.current.value = "";
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        datosReparador(event.target.value);
      } else {
        txtIdReparador.current.value = "";
      }
    }
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        btnAcepta.current.focus();
      }}
    >
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex align-items-center justify-content-between azulGradiant text-light">
        <h3 className="m-0 fw-bold">
          Impresión de Facturas - Otros Impuestos
        </h3>
        <a type="button" className="text-light fw-bold fs-6" onClick={cancelar}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 p-2">
          <fieldset className="col-12 m-0 p-2 border-azul rounded d-flex align-items-center justify-content-between flex-wrap">
            <legend className="float-none m-0 w-auto">
              Datos de la Factura
            </legend>
            <div className="col-8 m-0 p-0 ">
              <Select label = "Tipo de Ingreso:"
                ref={cmbTipoImpuesto}
                name="tipoingreso"
                id="inputCedula"
                onChange={onChange}
              >
                {records &&
                  records.map((item, index) => (
                    <option key={index} value={item.idtipoingreso}>
                      {" "}
                      {item.descripcion}{" "}
                    </option>
                  ))}
              </Select>
            </div>
            <div className="col-4 m-0 p-0 pl-2 ">
              <Input label = "Fecha:"
                disabled
                id="inputTotalDeclarado"
                defaultValue={moment.utc(fechaSistema).format("DD/MM/YYYY")}
              />
            </div>
            <fieldset className="col-12 m-0 my-2 p-2 border-azul rounded d-flex align-items-center justify-content-between">
              <legend className="float-none m-0 w-auto">
                Tipo de Contribuyente
              </legend>
              <Radio label = "General"
                ref={radioGeneral}
                name="radios"
                defaultChecked
                id="radios1"
                onChangeCapture={onCheck}
              />
              <Radio label = "Actividad Económica"
                ref={radioComercio}
                name="radios"
                id="radios2"
                onChangeCapture={onCheck}
              />
              <Radio label = "Inmuebles Urbanos"
                ref={radioInmueble}
                name="radios"
                id="radios3"
                onChangeCapture={onCheck}
              />
            </fieldset>

            <fieldset className="col-12 m-0 p-2 d-flex flex-wrap align-items-center justify-content-between border-azul rounded">
              <legend className="float-none m-0 w-auto">
                Datos del Contribuyente
              </legend>
              <div className="col-12 m-0 p-0 ">
                <SearchInput label = "Nombres:"
                  disabled={activo1}
                  ref={txtNombre}
                  id="inputNombre"
                  name="nombre"
                  onChange={onChange}
                  onClickButton = {handleCatalogo}
                  disabledButton = {activo}
                />
              </div>
              <div className="col-6 m-0 my-2 p-0 ">
                <Input label = "Cédula/Rif:"
                  disabled={activo1}
                  ref={txtRif}
                  id="inputRif"
                  name="rif"
                  onChange={onChange}
                />
              </div>
              <div className="col-12 m-0 p-0 ">
                <Textarea label = 'Dirección:'
                  ref={txtDireccion}
                  style={{ height: 70 }}
                  id="inputDireccion"
                  name="direccion"
                  onChange={onChange}
                />
              </div>
            </fieldset>
            <div className="col-12 m-0 p-0 d-flex align-items-center justify-conten-end flex-wrap">
              <div className="col-3 m-0 mt-2 p-0 ">
                <Input label = "Monto Total a Facturar:"
                  autoComplete="off"
                  align="right"
                  ref={txtMonto}
                  defaultValue={
                    values && values.monto
                      ? formatMoneda(
                          values.monto
                            .toString()
                            .replace(",", "")
                            .replace(".", ","),
                          ",",
                          ".",
                          2
                        )
                      : ""
                  }
                  onFocus={seleccionarCampo}
                  onBlur={handleInputMontoChange}
                  onKeyUp={handleInputMontoChange}
                  placeholder="0,00"
                />
              </div>
              <div className="col-12 m-0 my-2 p-0 ">
                <Textarea label = 'Concepto:'
                  ref={txtConcepto}
                  autoComplete="off"
                  style={{ height: 70 }}
                  id="inputTotalDeclarado"
                  name="concepto"
                  onChange={onChange}
                />
              </div>
              <div
                className="col-12 m-0 p-0 d-flex flex-wrap align-items-center justify-content-between"
                style={{ display: visibleF ? "flex" : "none" }}
              >
                <div className="col-2 m-0 p-0 ">
                  <SearchInput label = 'Id. Reparador:'
                    ref={txtIdReparador}
                    onKeyUp={validarReparador}
                    id="inputNombre"
                    name="idreparador"
                    onChange={onChange}
                    onClickButton = {handleCatalogoRep}
                  />
                </div>
                <div className="col-12 m-0 mt-2 p-0 ">
                  <Input label = "Nombre:"
                    disabled
                    ref={txtNombreReparador}
                    id="inputNombre"
                    name="nombre"
                    onChange={onChange}
                  />
                </div>
              </div>
            </div>
          </fieldset>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          ref={btnAcepta}
          onClick={onChangeValidar}
        >
          Aceptar
        </SuccessButton>
        <DangerButton
          ref={btnCancela}
          onClick={cancelar}
        >
            Cancelar
        </DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={handleCloseNo}
        onHideSi={handleCloseSi}
      />
      <Dimmer active={activate} inverted></Dimmer>
      <CatalogoComercio
        titulo={""}
        mensaje={""}
        show={mostrarCatCom}
        onHideCancelaCatCom={handleCloseCatalogo}
        onHideAceptaCatCom={handleAceptaCatalogo}
      />

      <CatalogoInmueble
        titulo={""}
        mensaje={""}
        show={mostrarCatInm}
        onHideCancelaCatInm={handleCloseCatalogo}
        onHideAceptaCatInm={handleAceptaCatalogo}
      />
      <CatalogoReparador
        titulo={""}
        mensaje={""}
        show={mostrarCatRep}
        onHideCancelaCat={handleCloseCatalogoRep}
        onHideAceptaCat={handleAceptaCatalogoRep}
      />
    </Modal>
  );
};
